import React, { Component } from 'react';
import Section from './Section.js'
import {reduxForm, Field} from 'redux-form';
import { withRouter } from 'react-router';
import { HotKeys } from "react-hotkeys";
import {FormattedHTMLMessage} from 'react-intl';

import generateValidator from './Validations/generateValidator';
import CustomAlert from '../components/CustomAlert.js';
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';
import SaveStepButton from './SaveStepButton';
import withAuthControl from '../auth/Auth.js';
import AttributeOptions from './AttributeOptions.js';

class GeneralWarrantyForm extends Component {

    constructor(props){
        super(props);
        this.state = {
            fields: {},
            initialForm: false,
            resources: [
                'general_warranty_type'
            ]
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const general_warranty_type = [{id: 0, name: 'Garante propietario o con bono de sueldo'},{id: 1, name: 'Hipoteca'},{id: 2, name: 'Prenda'},{id: 3, name: 'Aval de Sociedad de Garantía Recíproca (SGR)'}];
        const general_warranty = (
            <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                    <div className="form-group">
                        <AttributeOptions name="general_warranty_type" defaultValue="Tipo de Garantía" label="Tipo de Garantía" attributeName='general_warranty_type' attributeOptions={general_warranty_type} />
                    </div>
                </div>
            </div>
        );

        return (
            <Section className="intro_form">
            <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                    <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                    <FormattedHTMLMessage id="app.step_general_warranty" description="Type General Warranty"/>
                    <div className="show-desktop">
                        <SaveStepButton/>
                    </div>
                </div>
                <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                    {this.state.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá.... Por favor espere...' /> }
                        <div>
                            <form onSubmit={handleSubmit(this.props.addSubscriber)} className='pvc-form'>
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                                {error && <CustomAlert bsStyle="danger" message={error}/>}
                                    {general_warranty}
                                <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={submitting}>Continuar</button>
                            </form>
                        </div>
                        <div className="show-mobile">
                            <SaveStepButton/>
                        </div>
                </div>
            </div>
        </Section>
        );
    }
}

GeneralWarrantyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'general_warranty_type', required: true}]);

GeneralWarrantyForm = reduxForm({
    form: 'GeneralWarranty', // a unique name for this form
    validate,
})(GeneralWarrantyForm);

GeneralWarrantyForm = withRouter(GeneralWarrantyForm);

GeneralWarrantyForm = withAuthControl(GeneralWarrantyForm);

export default GeneralWarrantyForm;



/** WEBPACK FOOTER **
 ** ./src/components/GeneralWarrantyForm.js
 **/